import { axiosInstanceVirtualCard } from "../axios";
import { RequestResponse } from "../types";

export const getSecurity = async (
  issuerCode: string
): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceVirtualCard.get(
      `/api/v1/security/issuers/${issuerCode}`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to fetch security: Internal server error");
      return {
        error: true,
        message: "Unable to fetch  security: Internal server error",
        data: null
      };
    }
    console.error("Unable to fetch security: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};

export const getSupportedSecurity = async (): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceVirtualCard.get(
      `/api/v1/security/supports/`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error(
        "Unable to fetch supported security: Internal server error"
      );
      return {
        error: true,
        message: "Unable to fetch supported security: Internal server error",
        data: null
      };
    }
    console.error("Unable to fetch supported security: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};

export const createUpdateSecurity = async (
  issuerCode: string,
  requestData: object
): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceVirtualCard.put(
      `/api/v1/security/issuers/${issuerCode}`,
      requestData,
      { headers: { "Content-Type": "application/json" } }
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error(
        "Unable to fetch supported security: Internal server error"
      );
      return {
        error: true,
        message: "Unable to fetch supported security: Internal server error",
        data: null
      };
    }
    console.error("Unable to fetch supported security: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};
